/* eslint-disable react/display-name */
import * as React from 'react';

const Heart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M8,15H8L2.1,8.8h0a4,4,0,0,1,0-5.6,3.53,3.53,0,0,1,5.3,0l.6.5.5-.6a3.53,3.53,0,0,1,5.3,0,4,4,0,0,1,0,5.6h0L8,15Zm0-2.3,4.8-4.8h0a2.53,2.53,0,0,0,0-3.6,2.42,2.42,0,0,0-3.5,0L8,5.6,6.7,4.3a2.42,2.42,0,0,0-3.5,0,2.54,2.54,0,0,0,0,3.6h0L8,12.7ZM8,15H8L2.1,8.8h0a4,4,0,0,1,0-5.6,3.53,3.53,0,0,1,5.3,0l.6.5.5-.6a3.53,3.53,0,0,1,5.3,0,4,4,0,0,1,0,5.6h0L8,15Zm0-2.3,4.8-4.8h0a2.53,2.53,0,0,0,0-3.6,2.42,2.42,0,0,0-3.5,0L8,5.6,6.7,4.3a2.42,2.42,0,0,0-3.5,0,2.54,2.54,0,0,0,0,3.6h0L8,12.7Z"
      style={{ fill: 'inherit' }}
    />
  </svg>
);

export default Heart;
